<template>
    <Link :href="$$route(routing)" class="btn btn--primary" :class="{'active' : activeClass}"><slot></slot></Link>
</template>

<script>

export default {
    name: 'MenuNavItem',
    props: [
        'routing',
    ],
    computed: {
        fullRoute() {
            return this.getRoute('.' + this.routing);
        },
        activeClass() {
            return this.$route().current() === this.fullRoute ? 'active' : '';
        }
    }
};
</script>
